import { Component, inject, input, OnDestroy, OnInit, output, signal } from "@angular/core";
import { Button } from "../button/button";
import { TranslocoModule } from "@jsverse/transloco";
import { SafeHtmlPipe } from "src/app/shared/pipes/safe-html.pipe";
import { ModalService } from "src/app/core/services/modal-service";

@Component({
  selector: "app-input-modal",
  imports: [Button, SafeHtmlPipe, TranslocoModule],
  templateUrl: "./input-modal.html",
})
export class InputModal implements OnInit, OnDestroy {
  private readonly modalService = inject(ModalService);

  title = input.required<string>();
  placeholder = input<string>("");
  text = input<string>("");
  inputTitle = input<string>("");
  buttonText = input.required<string>();

  inputValue = signal<string>("");

  completeModal = output<string>();
  closeModal = output<void>();

  ngOnInit(): void {
    this.modalService.register();
  }

  ngOnDestroy(): void {
    this.modalService.unregister();
  }
}
